module.exports = __webpack_public_path__ + "img/schedule-network.6171cfbb.svg";